module.exports = __webpack_public_path__ + "static/media/tvg.2033a828.svg";